import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../Shared/Services/api.service';
import { endpoints } from '../../../../environments/endpoints';
import { LaravelDefaultResponse } from '../../../Interfaces/api/shared/response.interface';
import { SubscriptionShowResponse } from '../../../Interfaces/api/backoffice/subscription.interface';
import { TypedResourceRequest } from '../../Shared/Interfaces/api-request.interface';
import { OrganizationSubscription } from '../../../Models/backoffice/organization-subscription.model';

@Injectable({
  providedIn: 'root',
})
export class OrganizationSubscriptionService {
  private readonly _apiService = inject(ApiService);

  showRequest(
    organizationId: string,
  ): TypedResourceRequest<LaravelDefaultResponse<SubscriptionShowResponse>> {
    return this._apiService.get<LaravelDefaultResponse<SubscriptionShowResponse>>(
      endpoints.backoffice.organizationSubscription(organizationId),
      { skipLoading: true, skipError: true },
    );
  }

  toSubscription(
    response: LaravelDefaultResponse<SubscriptionShowResponse> | undefined,
  ): OrganizationSubscription | null {
    return response?.data?.subscription
      ? new OrganizationSubscription(response.data.subscription)
      : null;
  }
}
